import { createIcon } from '../shared'

const CommentIcon = createIcon(
  ({ color }) => (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.0039 7C20.0039 6.46957 19.7932 5.96086 19.4181 5.58579C19.043 5.21071 18.5343 5 18.0039 5H6.00391C5.47347 5 4.96477 5.21071 4.58969 5.58579C4.21462 5.96086 4.00391 6.46957 4.00391 7V15C4.00391 15.5304 4.21462 16.0391 4.58969 16.4142C4.96477 16.7893 5.47347 17 6.00391 17H8.00391C8.26912 17 8.52348 17.1054 8.71101 17.2929C8.89855 17.4804 9.00391 17.7348 9.00391 18V19.918L12.3789 17.218C12.5565 17.0765 12.7769 16.9996 13.0039 17H18.0039C18.5343 17 19.043 16.7893 19.4181 16.4142C19.7932 16.0391 20.0039 15.5304 20.0039 15V7ZM22.0039 15C22.0039 16.0609 21.5825 17.0783 20.8323 17.8284C20.0822 18.5786 19.0648 19 18.0039 19H13.3559L8.62891 22.781C8.4817 22.8984 8.30438 22.9718 8.1173 22.993C7.93022 23.0141 7.74098 22.9821 7.57129 22.9005C7.4016 22.8189 7.25836 22.6912 7.15799 22.5319C7.05763 22.3726 7.00423 22.1883 7.00391 22V19H6.00391C4.94304 19 3.92562 18.5786 3.17548 17.8284C2.42533 17.0783 2.00391 16.0609 2.00391 15V7C2.00391 5.93913 2.42533 4.92172 3.17548 4.17157C3.92562 3.42143 4.94304 3 6.00391 3H18.0039C19.0648 3 20.0822 3.42143 20.8323 4.17157C21.5825 4.92172 22.0039 5.93913 22.0039 7V15Z"
      fill={color}
    />
  ),
  '0 0 24 24',
  'CommentIcon',
)

export { CommentIcon }
